// ─── "מה הזיז את התיק" · each holding's share of the day's move ─────────────
//
// Deterministic arithmetic, no model (sprint 18, stage 1). For every holding
// with a live price and a previous close:
//
//   weight        = its value at the previous close ÷ the portfolio's value at
//                   the previous close
//   contribution  = its daily change % × weight   (percentage points)
//
// The weight is taken at the previous close on purpose. With that weight the
// contributions add up EXACTLY to the portfolio's daily change:
//   Σ (prev_i / P) × (now_i − prev_i) / prev_i  =  (N − P) / P
// A weight at today's price would leave a residue the reader cannot account
// for, and "the parts do not add up to the whole" is a claim this card must
// never make by accident.
//
// No quote, no previous close, or no shares · not a row, and not in the
// total: a holding without a quote has no move today.

export function portfolioMovers(portfolio) {
  const rows = [];
  let now = 0, prev = 0;
  for (const p of portfolio || []) {
    if (p.quote === "none") continue;
    if (!(p.shares > 0) || !(p.currentPrice > 0) || !(p.prevClose > 0)) continue;
    rows.push({
      symbol: p.symbol,
      pct: ((p.currentPrice - p.prevClose) / p.prevClose) * 100,
      prevValue: p.prevClose * p.shares,
    });
    now  += p.currentPrice * p.shares;
    prev += p.prevClose    * p.shares;
  }
  if (!(prev > 0)) return { rows: [], total: null };
  for (const r of rows) {
    r.weight = (r.prevValue / prev) * 100;          // percent of the portfolio
    r.points = (r.pct * r.weight) / 100;            // percentage points
    delete r.prevValue;
  }
  rows.sort((a, b) => Math.abs(b.points) - Math.abs(a.points));
  return { rows, total: { pct: ((now - prev) / prev) * 100 } };
}

// The `n` largest contributions by absolute value.
export function topMovers(portfolio, n = 3) {
  const { rows, total } = portfolioMovers(portfolio);
  return { rows: rows.slice(0, n), all: rows.length, total };
}

// The `n` largest contributions, and the rest as one row (sprint 19, stage 3):
// how many holdings it covers and their contribution together. `scale` is the
// largest absolute contribution on the card, the rest row included · each
// bar's length is its share of it.
export function moversWithRest(portfolio, n = 3) {
  const { rows, total } = portfolioMovers(portfolio);
  const top = rows.slice(0, n);
  const others = rows.slice(n);
  const rest = others.length ? { count: others.length, points: others.reduce((a, r) => a + r.points, 0) } : null;
  const scale = Math.max(0, ...top.map(r => Math.abs(r.points)), rest ? Math.abs(rest.points) : 0);
  return { rows: top, rest, total, scale };
}
